import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { useTranslation } from "react-i18next";
import PlanCard, { PlanFeature } from "./PlanCard";
import { useStore } from "../../store/store";
import { MaxAllowedFreeCharts } from "../../constants";

interface FreePlanCardProps {
  onButtonClick?: () => void;
  isCurrentPlan?: boolean;
}

const FreePlanCard: React.FC<FreePlanCardProps> = ({
  onButtonClick,
  isCurrentPlan,
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const chartsCount = useStore((state) => state.chartsCount);

  const freePlanFeatures: PlanFeature[] = [
    {
      feature: t("subscription_page.features.unlimited_charts_office"),
      included: true,
    },
    {
      feature: t("subscription_page.features.charts_saved_cloud"),
      included: true,
    },
    { feature: t("subscription_page.features.basic_export"), included: true },
    {
      feature: t("subscription_page.features.custom_branding"),
      included: false,
    },
  ];

  const renderFeatureIcon = (included: boolean) => {
    return included ? (
      <CheckOutlined style={{ color: token.colorSuccess }} />
    ) : (
      <CloseOutlined style={{ color: token.colorError }} />
    );
  };

  let noMoreChartsAllowed = false;
  let buttonText = t("subscription_page.select_free_plan");
  if (isCurrentPlan) {
    if (chartsCount < MaxAllowedFreeCharts) {
      buttonText = t("subscription_page.create_chart_for_free");
    } else {
      buttonText = t("subscription_page.max_charts_reached");
      noMoreChartsAllowed = true;
    }
  }

  return (
    <PlanCard
      title={t("subscription_page.free")}
      subtitle={t("subscription_page.for_casual_users")}
      price={t("subscription_page.price_free")}
      buttonText={buttonText}
      features={freePlanFeatures}
      renderFeatureIcon={renderFeatureIcon}
      onButtonClick={noMoreChartsAllowed ? undefined : onButtonClick}
      isSelected={isCurrentPlan}
      ribbonColor="#8c8c8c"
      ribbonText={
        isCurrentPlan ? t("subscription_page.your_current_plan") : undefined
      }
    />
  );
};

export default FreePlanCard;
